import { render, staticRenderFns } from "./PlatingTV.vue?vue&type=template&id=2b0729f6&"
import script from "./PlatingTV.vue?vue&type=script&lang=js&"
export * from "./PlatingTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports